import { render, staticRenderFns } from "./UserActionConfirm.vue?vue&type=template&id=e4d8b6aa&"
import script from "./UserActionConfirm.vue?vue&type=script&lang=js&"
export * from "./UserActionConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports